import { render } from "./UserProfileTCSvg.vue?vue&type=template&id=1df3c8f2"
import script from "./UserProfileTCSvg.vue?vue&type=script&lang=js"
export * from "./UserProfileTCSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__